export default "__VITE_ASSET__CD9twot6__"